import { create } from "../../../../../common/utils/zustand_state_manager";


type State = {
  maquinaEquip: number[] | null;
  dataEntradaDe: Date | null,
  dataEntradaAte: Date | null,
  codigo: string | null;
};

type Actions = {
  clear: () => void;
};

export const useMaquinasEquipItensControleFilters = create<State & Actions>((set) => ({
  dataEntradaDe: null,
  dataEntradaAte: null,
  maquinaEquip: null,
  codigo: null,
  clear: () => set({ maquinaEquip: null, dataEntradaDe: null, dataEntradaAte: null, codigo: null }),
}));
